<template>
  <div>
    <!--面包屑-->
    <Breadcrumb :dataSource="breadcrumbList" />

    <!-- 顶部新区域：整合后的统计组件 -->
    <AbnormalFeedback
      :tabPaneConfig="tabPaneConfig"
      @viewDetail="viewFeedbackDetail"
    />

    <!-- 底部原区域：采集异常学生筛查 -->
    <AbnormalStudentScreening
      :tabPaneConfig="tabPaneConfig"
      @viewDetail="viewScreeningDetail"
    />

    <!-- 旧详情弹窗（服务于底部筛查） -->
    <NotCollectedDetailModal ref="notCollectedDetailModalRef" :tabKey="tabKey" />
    <!-- 新详情弹窗（服务于顶部反馈统计） -->
    <FeedbackDetailModal ref="feedbackDetailModalRef" />
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb/index'
import NotCollectedDetailModal from './components/NotCollectedDetailModal'
import FeedbackDetailModal from './components/FeedbackDetailModal'
import AbnormalFeedback from './components/AbnormalFeedback'
import AbnormalStudentScreening from './components/AbnormalStudentScreening'

export default {
  name: 'NotCollectedBasemap',
  components: {
    Breadcrumb,
    NotCollectedDetailModal,
    FeedbackDetailModal,
    AbnormalFeedback,
    AbnormalStudentScreening,
  },
  data() {
    return {
      breadcrumbList: [
        {
          label: '心理工作概览',
          isBack: true,
        },
        {
          label: '未采集情况',
        },
      ],
      tabKey: 1,
      // tab列表配置
      tabPaneConfig: [
        {
          tab: '有底图未采集',
          key: 1,
        },
        {
          tab: '未录入人脸',
          key: 2,
        },
        {
          tab: '活跃度低',
          key: 3,
        },
      ],
    }
  },
  methods: {
    // 底部筛查列表的详情（旧逻辑）
    viewScreeningDetail(record, tabKey) {
      if (tabKey) {
        this.tabKey = tabKey
      }
      this.$refs.notCollectedDetailModalRef.showModal(record)
    },
    // 顶部反馈统计表的详情（新逻辑）
    viewFeedbackDetail(record, tabKey, dateRange) {
      this.$refs.feedbackDetailModalRef.showModal(record, tabKey, dateRange)
    },
  },
}
</script>

<style scoped lang="less">
.title-2 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
}
</style>
